import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import api from 'config/api';
import { RootState } from 'store/store';
import { PostArray } from 'types/post';

export interface PostState {
  status: 'idle' | 'loading' | 'successed' | 'error';
  entities: PostArray;
}

const initialState: PostState = {
  entities: [],
  status: 'idle',
};

export const fetchLatestPosts = createAsyncThunk(
  'post/fetchLatestPosts',
  async () => {
    const response = await fetch(api.post);
    return await response.json();
  }
);

export const postSlice = createSlice({
  name: 'post',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchLatestPosts.pending, (state) => {
      state.status = 'loading';
    });

    builder.addCase(fetchLatestPosts.fulfilled, (state, action) => {
      state.status = 'successed';
      state.entities = action.payload.data;
    });
  },
});

export const postSelector = (state: RootState) => state.post;

export default postSlice.reducer;
